(() => {
  const root = document.querySelector('[data-zi-pdp]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-zi-variants]').textContent);
  const form = root.querySelector('[data-zi-buy]');
  const idInput = form.elements.id;
  const qty = form.querySelector('input[name=quantity]');
  const btn = form.querySelector('.zi-buy__btn');
  const stage = root.querySelector('.zi-stage');
  const findVariant = () => {
    const chosen = [...root.querySelectorAll('.zi-opt')].map((fs) => fs.querySelector('input:checked').value);
    return data.find((v) => v.options.every((o, i) => o === chosen[i]));
  };
  const showMedia = (mediaId) => {
    if (!mediaId) return;
    const img = stage.querySelector(`[data-media="${mediaId}"]`);
    if (!img) return;
    if (window.matchMedia('(max-width: 990px)').matches) { stage.scrollTo({ left: img.offsetLeft, behavior: 'smooth' }); return; }
    stage.querySelectorAll('img[data-media]').forEach((el) => { el.hidden = el !== img; });
    root.querySelectorAll('.zi-thumb').forEach((t) => t.setAttribute('aria-current', t.dataset.media === String(mediaId)));
  };
  const render = (v) => {
    const stock = root.querySelector('[data-zi-stock]');
    root.querySelectorAll('.zi-opt').forEach((fs, i) => { fs.querySelector('legend span').textContent = v ? v.options[i] : ''; });
    if (!v) { btn.disabled = true; btn.textContent = 'Niet beschikbaar'; return; }
    idInput.value = v.id;
    root.querySelector('[data-zi-price]').innerHTML = v.price;
    root.querySelector('[data-zi-compare]').innerHTML = v.compare || '';
    stock.dataset.state = v.state;
    stock.querySelector('span').textContent = v.stock_text;
    qty.max = v.max || '';
    btn.disabled = !v.available;
    btn.textContent = v.available ? btn.dataset.label : 'Uitverkocht';
    showMedia(v.media);
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
  };
  root.addEventListener('change', (e) => { if (e.target.closest('.zi-opt')) render(findVariant()); });
  root.addEventListener('click', (e) => {
    const t = e.target.closest('.zi-thumb');
    if (t) showMedia(t.dataset.media);
    const step = e.target.closest('[data-step]');
    if (step) {
      const max = parseInt(qty.max || '999', 10);
      qty.value = Math.min(max, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(step.dataset.step, 10)));
    }
  });
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    btn.disabled = true;
    try {
      await window.ziCart.add(idInput.value, parseInt(qty.value, 10) || 1);
      btn.textContent = 'Toegevoegd aan je mandje';
      setTimeout(() => { btn.textContent = btn.dataset.label; }, 2000);
    } catch (err) { alert(err.message || 'Toevoegen mislukt'); }
    finally { btn.disabled = false; }
  });
  const rel = document.querySelector('[data-zi-rel]');
  if (rel) fetch(rel.dataset.url).then((r) => r.text()).then((html) => {
    const d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zi-rel]');
    if (d && d.querySelector('.zi-card')) rel.innerHTML = d.innerHTML; else rel.closest('section').hidden = true;
  });
})();
